import React, { useState, useEffect } from "react"
import { 
   ArrowLeftOutlined, 
   CloseOutlined, 
   PlusOutlined 
} from "@ant-design/icons"
import {
   Button,
   Col,
   Form,
   Input,
   Row,
   Spin
} from "antd"
import {
   useNavigate,
   useParams
} from "react-router-dom";
import { t } from "i18next"
import moment from "moment";
import swal from "sweetalert";
import * as _ from "lodash";
import {
   getPerformanceModules
} from "services/pdd";
import {
   getAppraisalById,
   createNewAppraisal,
   updateAppraisalById,
   submitAppraisal
} from "services/appraisal";
import {
   InputRangeDate
} from "common/elements";
import { Util } from "common/util";

export default function InsertAndUpdateForm() {
   const [performanceModules, setPerformanceModules] = useState({});
   const [state, setState] = useState({loading: false, submitting: false});
   const [appraisals, setAppraisals] = useState([]);

   const navigate = useNavigate();
   const [form] = Form.useForm();
   
   const { id } = useParams();

   const isCanSelfEvaluate = Util.getInstance().hasPermission("self evaluation", "evaluation");
   const isCanEvaluate = Util.getInstance().hasPermission("evaluation", "evaluation");

   useEffect(() => {
      if (id) {
         changeStateByKey("loading", true);
         getAppraisalById(id)
         .then(response => {
            if (response) {
               const data = response.data;
               setPerformanceModules(data);
               setAppraisals(data.quarterlyReviewEntries);
               form.setFieldsValue({reviewedDate: moment(data.reviewedDate)});
            }
         })
         .finally(() => changeStateByKey("loading", false));
      } else {
         changeStateByKey("loading", true);
         getPerformanceModules("year-end-appraisal")
         .then(response => {
            setPerformanceModules(response);
         })
         .finally(() => changeStateByKey("loading", false));
      }
      // eslint-disable-next-line
   }, [])

   const changeStateByKey = (key, value) => {
      setState(prevState => ({...prevState, [`${key}`]: value}));
   }

   const onCreateOrUpdateAppraisal = (values) => {
      const data = {
         employeeId: performanceModules.employeeId,
         selfEvalDate: moment(values.selfEvalDate).format("YYYY-MM-DD"),
         employeeEvaluatioEntries: appraisals
      };

      changeStateByKey("saving", true);

      if (id) {
         updateAppraisalById(id, data)
         .then(() => {
            onBack();
         })
         .finally(() => changeStateByKey("saving", false));
      } else {
         createNewAppraisal(data)
         .then(() => {
            onBack();
         })
         .catch(error => {
            if (error.response.status === 400) {
               swal({
                  title: "We're sorry",
                  text: error?.response?.data?.error?.message,
                  icon: "error",
                  dangerMode: true,
               })
            }
         })
         .finally(() => changeStateByKey("saving", false));
      }
   }

   const onSubmitAppraisal = () => {
      swal({
         title: "Are you sure?",
         text: "You are about to submit self evaluation to your manager.",
         icon: "warning",
         buttons: ["Cancel", "Submit"],
         dangerMode: true,
      })
      .then(yesSubmit => {
         if (yesSubmit) {
            changeStateByKey("submitting", true);
            
            const data = {
               employeeEvaluatioEntries: appraisals
            };

            submitAppraisal(id, data)
            .then(() => {
               onBack();
            })
            .finally(() => {
               changeStateByKey("submitting", false);
            });
         }
      });
   }

   const onBack = () => {
      navigate(-1);
   }

   const onChageTextArea = (key, value, performanceModuleId) => {
      const foundPerformanceModuleId = appraisals.find((employeeEvaluatioEntry) => employeeEvaluatioEntry.performanceModuleId === performanceModuleId);
      if (foundPerformanceModuleId) {
         foundPerformanceModuleId[key] = value;
      } else {
         appraisals.push({
            performanceModuleId: performanceModuleId,
            [key]: value
         });
         setAppraisals([...appraisals])
      }
   }
   
   return (
      <>
         <Form form={form} onFinish={onCreateOrUpdateAppraisal}>
            <Row className="btn-navigation">
               <Col span={12}>
                  <div className="pull-left">
                     <Button onClick={onBack}>
                        <ArrowLeftOutlined />
                        {t("text_back")}
                     </Button>
                     <span className="title">
                        {id ? "Edit Year-End Appraisal" : "Create Year-End Appraisal"}
                     </span>
                  </div>
               </Col>
               <Col span={12}>
                  <div className="pull-right">
                     {
                        id && performanceModules?.evaluateStatus === "PENDING" && <Button style={{backgroundColor: "rgb(184 184 0)", borderColor: "rgb(184 184 0)", color: "white"}} disabled={state.submitting} onClick={onSubmitAppraisal}>Submit</Button>
                     }
                     <Button htmlType="submit" style={{ marginLeft: 15 }} disabled={state.saving} loading={state.saving}>Save</Button>
                  </div>
               </Col>
            </Row>
            {
               state.loading ? <Spin spinning={state.loading} style={{ display: "flex", height: "84vh", justifyContent: "center", width: "100%", alignItems: "center" }} /> :
                  <div style={{ padding: 15, height: "84vh", overflowY: "auto" }}>

                     <div style={{ display: "flex", justifyContent: 'flex-start', alignItems: 'center', marginLeft: 5 }}>
                        <img
                           style={{ width: "60px", height: "60px", objectFit: "cover" }}
                           src="/logo.png"
                           alt="Logo"
                        />
                        <h2 style={{
                           fontSize: 14,
                           fontWeight: 500,
                           marginLeft: 15
                        }}>Norwegian People's Aid Cambodia</h2>
                     </div>

                     <p style={{ fontSize: 18, fontWeight: 600, color: "#1d8747", marginTop: 15 }}>Performance and Development Dialogue / ការសន្ទនាពីការងារ និងការអភិវឌ្ឍសមត្ថភាព</p>
                     <table className="performance-evaluation" id="salary-scale">
                        <tbody>
                           <tr>
                              <td colSpan={3} style={{ backgroundColor: "#ebf1dd" }}>
                                 <div style={{ paddingLeft: 7 }} dangerouslySetInnerHTML={{ __html: performanceModules.title }} />
                              </td>
                           </tr>
                           <tr>
                              <td>
                                 <p className="objectives-setting-p">Name of employee: <span className="objectives-setting-sub-p">{performanceModules?.employee?.fullName}</span></p>
                                 <p className="objectives-setting-sub-p">ឈ្មោះបុគ្គលិក</p>
                              </td>
                              <td>
                                 <p className="objectives-setting-p">Position: <span className="objectives-setting-sub-p">{performanceModules?.employee?.position}</span></p>
                                 <p className="objectives-setting-sub-p">តួនាទី</p>
                              </td>
                              <td>
                                 <p className="objectives-setting-p">Dept./programme/unit: <span className="objectives-setting-sub-p">{performanceModules?.employee?.department}</span></p>
                                 <p className="objectives-setting-sub-p">នាយកដ្ឋាន/កម្មវិធី/ផ្នែក</p>
                              </td>
                           </tr>
                           
                           {
                              performanceModules.level1s && performanceModules.level1s.map((level1) => {
                                 let colSpanLevel1;
                                 let colSpanLevel1Action1;
                                 let level1NumberOfAction = 0;
                                 const numberChildLevel1 = level1.level2s.length;

                                 if (level1.action1 && level1.action2) {
                                    colSpanLevel1 = 0;
                                    colSpanLevel1Action1 = 0;
                                    level1NumberOfAction = 2;
                                 } else if (level1.action1) {
                                    colSpanLevel1 = 0;
                                    colSpanLevel1Action1 = 2;
                                    level1NumberOfAction = 1;
                                 } else {
                                    colSpanLevel1 = 3;
                                    colSpanLevel1Action1 = 0;
                                 }

                                 return <React.Fragment key={level1.id}>
                                    <tr key={level1.id} style={{ backgroundColor: "#ebf1dd" }}>
                                       <td colSpan={colSpanLevel1}>
                                          <Title title={level1.title} />
                                       </td>

                                       {
                                          level1.action1 && 
                                          <td colSpan={colSpanLevel1Action1}>
                                             <Title title={level1.action1} />
                                          </td>
                                       }

                                       {
                                          level1.action2 && 
                                          <td>
                                             <Title title={level1.action2} />
                                          </td>
                                       }
                                    </tr>
                                    
                                    {
                                       level1.layout === "horizontal" ?
                                       <RenderHorizontalRow parentModule={level1} performanceModules={level1.level2s} onChageTextArea={onChageTextArea} />
                                       :
                                       level1.level2s.map((level2, level2Index) => {
                                          return <React.Fragment key={level2.id}>
                                             {/* ================ START RENDER ROW LEVEL 2 ================  */}
                                             {
                                                level2.action1 && level2.action2 ?
                                                   <tr style={{ backgroundColor: "#ebf1dd" }}>
                                                      <td>
                                                         <Title title={level2.title} />
                                                      </td>
                                                      <td>
                                                         <Title title={level2.action1} />
                                                      </td>
                                                      <td>
                                                         <Title title={level2.action2} />
                                                      </td>
                                                   </tr>
                                                   :
                                                   level2.action1 ?
                                                      <tr style={{ backgroundColor: "#ebf1dd" }}>
                                                         <td>
                                                            <Title title={level2.title} />
                                                         </td>
                                                         <td colSpan={2}>
                                                            <Title title={level2.action1} />
                                                         </td>
                                                      </tr>
                                                      :
                                                      <>
                                                         {
                                                            level2.reportable ?
                                                               <>
                                                                  {
                                                                     level1NumberOfAction === 2 &&
                                                                     <tr style={{ backgroundColor: "#ebf1dd" }}>
                                                                        <td>
                                                                           <Title title={level2.title} />
                                                                        </td>
                                                                        {
                                                                           level2Index === 0 &&
                                                                           <>
                                                                              <td rowSpan={numberChildLevel1}>
                                                                                 {isCanSelfEvaluate && <Input.TextArea placeholder="Enter your description here ...." defaultValue={level1.content1} onChange={(event) => onChageTextArea("content1", event.target.value, level1.id)} />}
                                                                              </td>
                                                                              <td rowSpan={numberChildLevel1}>
                                                                                 {isCanEvaluate && <Input.TextArea placeholder="Enter your description here ...." defaultValue={level1.content2} onChange={(event) => onChageTextArea("content2", event.target.value, level1.id)} />}
                                                                              </td>
                                                                           </>
                                                                        }
                                                                     </tr>
                                                                  }

                                                                  {
                                                                     level1NumberOfAction === 1 && 
                                                                     <tr>
                                                                        <td>
                                                                           <Title title={level2.title} />
                                                                        </td>
                                                                        {
                                                                           level2Index === 0 && 
                                                                           <td colSpan={2} rowSpan={numberChildLevel1}>
                                                                              {isCanSelfEvaluate && <Input.TextArea placeholder="Enter your description here ...." defaultValue={level1.content1} onChange={(event) => onChageTextArea("content1", event.target.value, level1.id)} />}
                                                                           </td>
                                                                        }
                                                                     </tr>
                                                                  }
                                                                  {
                                                                     level1NumberOfAction === 0 && 
                                                                     <tr style={{ backgroundColor: "#ebf1dd" }}>
                                                                        <td colSpan={3} style={{padding: 0}}>
                                                                           <div>
                                                                              <Title title={level2.title} style={{borderBottom: "1px solid #000", paddingLeft: 5}} />
                                                                              {isCanSelfEvaluate && <InputDescription fieldName="content1" performanceModule={level2} onChageTextArea={onChageTextArea}  />}
                                                                           </div>
                                                                        </td>
                                                                     </tr>
                                                                  }
                                                               </>
                                                               :
                                                               <tr style={{ backgroundColor: "#ebf1dd" }}>
                                                                  <td colSpan={3}>
                                                                     <Title title={level2.title} />
                                                                  </td>
                                                               </tr>
                                                         }
                                                      </>
                                             }
                                             {/* ================ END RENDER ROW LEVEL 2 ================  */}

                                             {/* ================ START RENDER ROW LEVEL 3 ================  */}

                                             {
                                                level2.layout === "horizontal" ? 
                                                <RenderHorizontalRow parentModule={level2} performanceModules={level2.level3s} onChageTextArea={onChageTextArea} />
                                                :
                                                level2.level3s.map((level3, level3Index) => {
                                                   const numberChildLevel2 = level2.level3s.length;

                                                   let level2NumberOfAction = 0;
                                                   if (level2.action1 && level2.action2) {
                                                      level2NumberOfAction = 2;
                                                   } else if (level2.action1) {
                                                      level2NumberOfAction = 1;
                                                   }

                                                   if (level1NumberOfAction === 2 || level2NumberOfAction === 2) {
                                                      return <tr key={level3.id}>
                                                         <td>
                                                            <Title title={level3.title} style={{paddingLeft: 20}} />
                                                         </td>
                                                         {
                                                            level3Index === 0 && 
                                                            <>
                                                               <td rowSpan={numberChildLevel2}>
                                                                  {isCanSelfEvaluate && <InputDescription fieldName="content1" performanceModule={level2} onChageTextArea={onChageTextArea} />}
                                                               </td>
                                                               <td rowSpan={numberChildLevel2}>
                                                                  {isCanEvaluate && <InputDescription fieldName="content2" performanceModule={level2} onChageTextArea={onChageTextArea} />}
                                                               </td>
                                                            </>
                                                         }
                                                      </tr>
                                                   } else if (level2NumberOfAction === 2) {
                                                      return <tr key={level3.id}>
                                                         <td>
                                                            <Title title={level3.title} style={{paddingLeft: 20}} />
                                                         </td>
                                                         <td colSpan={2}>
                                                            {isCanSelfEvaluate && <Input.TextArea placeholder="Enter your description here ...." defaultValue={level3.content1 && level3.content1} onChange={(event) => onChageTextArea("content1", event.target.value, level3.id)} />}
                                                         </td>
                                                      </tr>
                                                   } else {
                                                      return <React.Fragment key={level3.id}>
                                                         <tr>
                                                            <td colSpan={3}>
                                                               <Title title={level3.title} style={{paddingLeft: 20}} />
                                                            </td>
                                                         </tr>
                                                         <tr>
                                                            <td colSpan={3}>
                                                               {isCanSelfEvaluate && <InputDescription fieldName="content1" performanceModule={level3} onChageTextArea={onChageTextArea} /> }
                                                            </td>
                                                         </tr>
                                                      </React.Fragment>
                                                   }
                                                })
                                             }
                                             {/* ================ END RENDER ROW LEVEL 3 ================  */}
                                          </React.Fragment>
                                       })
                                    }
                                 </React.Fragment>
                              })
                           }
                        </tbody>
                     </table>
                  </div>
            }
         </Form>
      </>
   )
}

function RenderHorizontalRow({parentModule, performanceModules, onChageTextArea}) {
   const [entries, setEntries] = React.useState([]);

   React.useEffect(() => {
      try {
         if (parentModule.content1) {
            setEntries(JSON.parse(parentModule.content1));
         }
      } catch (error) {}

      // eslint-disable-next-line
   }, []);

   performanceModules = _.sortBy(performanceModules, "order");

   const onChangeValue = (row, moduleId, cellValue) => {
      const foundEntryRow = entries.find((entry, index) => index === row);
      const foundModuleEntry = foundEntryRow.modules.find(module => module.moduleId === moduleId);
      foundModuleEntry["content"] = cellValue;

      onChageTextArea("content1", JSON.stringify(entries), parentModule.id);

   };

   const onSelectDate = (row, moduleId, cellDateValues) => {
      const foundEntryRow = entries.find((entry, index) => index === row);
      const foundModuleEntry = foundEntryRow.modules.find(module => module.moduleId === moduleId);
      if (cellDateValues) {
         foundModuleEntry["content"] = [cellDateValues[0].format("YYYY-MM-DD"), cellDateValues[1].format("YYYY-MM-DD")];
      } else {
         foundModuleEntry["content"] = null;
      }

      onChageTextArea("content1", JSON.stringify(entries), parentModule.id);
   };

   const onAddNew = (performanceModules) => {
      const modules = [];
      performanceModules.forEach(performanceModule => {
         modules.push({moduleId: performanceModule.id, content: "", inputType: performanceModule.inputType});
      });

      const newEntries = [...entries, {uniqueId: Date.now(), modules}];
      setEntries(newEntries);
   }

   const onRemove = (uniqueId) => {
      const foundAtIndex = entries.findIndex(entry => entry.uniqueId === uniqueId);

      entries.splice(foundAtIndex, 1);

      setEntries([...entries]);

      onChageTextArea("content1", JSON.stringify(entries), parentModule.id);
   }

   return <tr>
      <td colSpan={3} style={{padding: 0}}>
         <table style={{tableLayout: "fixed", width: "100%"}}>
            <tbody>
               <tr>
                  {
                     performanceModules.map((performanceModule, key) => 
                        <td key={performanceModule.id} style={{width: `${performanceModules.length}%`, borderWidth: 0, borderLeftWidth: key === 0 ? 0 : 1, padding: 0}}>
                           {
                              // Display only description when parent enable add new option
                              parentModule.enableMultiRow ?
                              <div dangerouslySetInnerHTML={{ __html: performanceModule.title }} style={{paddingLeft: 5}} />
                              :
                              <div>
                                 <div dangerouslySetInnerHTML={{ __html: performanceModule.title }} style={{paddingLeft: 5, borderBottom: "1px solid #000"}} />
                                 <Input.TextArea rows={8} placeholder="Enter your description here....." defaultValue={performanceModule.content1 ? performanceModule.content1 : performanceModule.defaultDescription} onChange={(event) => onChageTextArea("content1", event.target.value, performanceModule.id)} />
                              </div>
                           }
                        </td>
                     )
                  }
               </tr>
               {
                  entries.map(({uniqueId, modules}, entryKey) => {

                     return <tr key={uniqueId}>
                        {
                           modules.map(({moduleId, content, inputType}, columnKey) => 
                              <td key={columnKey} style={{borderLeftWidth: columnKey === 0 ? 0 : 1, borderRightWidth: columnKey === modules.length - 1 ? 0 : 1}}>
                                 <div style={{position: "relative"}}>
                                    {
                                       inputType === "date" ?
                                       <div style={{paddingLeft: 15, paddingRight: 15}}>
                                          <InputRangeDate
                                             name={`date-${uniqueId}-${moduleId}-${columnKey}`}
                                             placeholder={"Select timeline"}
                                             initialValue={content ? [moment(content[0]), moment(content[1])] : []}
                                             format={"DD/MM/YYYY"}
                                             allowClear={true}
                                             separator={"~"}
                                             style={{width: "100%"}}
                                             onChange={date => onSelectDate(entryKey, moduleId, date)}
                                          />
                                       </div>
                                       :
                                       <Input.TextArea key={columnKey} rows={3} placeholder="Enter your description here....." defaultValue={content}  onChange={(event) => onChangeValue(entryKey, moduleId, event.target.value)} />
                                    }

                                    {
                                       columnKey === modules.length - 1 && 
                                       <Button type="primary" danger shape="circle" icon={<CloseOutlined />} onClick={() => onRemove(uniqueId)} style={{marginLeft: 15, position: "absolute", top: 0, right: 0}} />
                                    }
                                 </div>
                              </td>
                           )
                        }
                     </tr>;
                  })
               }
            </tbody>
            {
               parentModule.enableMultiRow === 1 && 
               <tfoot>
                  <tr>
                     <td colSpan={performanceModules.length} style={{borderWidth: 0, borderTopWidth: 1, paddingRight: 10, paddingLeft: 10}}>
                        <Button type="dashed" icon={<PlusOutlined />} style={{ width: "100%" }} onClick={() => onAddNew(performanceModules)}>
                           {t("text_add_new")}
                        </Button>
                     </td>
                  </tr>
               </tfoot>
            }
         </table>
      </td>
   </tr>;
}

function Title({title, style}) {
   return <div style={style} dangerouslySetInnerHTML={{ __html: title }} />;
}

function InputDescription({fieldName, performanceModule, onChageTextArea}) {
   return <Input.TextArea 
      placeholder="Enter your description here ...."
      rows={performanceModule.numRow} 
      defaultValue={performanceModule[fieldName]} 
      onChange={event => onChageTextArea(fieldName, event.target.value, performanceModule.id)} 
   />;
}

Title.defaultProps = {
   style: {
      paddingLeft: 5
   }
};
